import React from "react";
import { useParams, Link } from "react-router-dom";
import PageLayout, { SectionReveal } from "../components/PageLayout";
import { Calendar, Clock, ArrowLeft, User } from "lucide-react";
import blogPosts from "../data/blogPosts";

const BlogPostPage = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <PageLayout>
        <section className="py-32 px-6 text-center" style={{ minHeight: "60vh" }}>
          <h1 className="text-[28px] font-bold mb-4" style={{ color: "var(--fg)" }}>Yazı Bulunamadı</h1>
          <p className="text-[15px] mb-8" style={{ color: "var(--fg)", opacity: 0.7 }}>Aradığınız blog yazısı mevcut değil.</p>
          <Link to="/blog" className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-[14px] transition-all duration-200" style={{ background: "var(--brand-navy)", color: "#fff" }}>
            <ArrowLeft size={16} /> Blog'a Dön
          </Link>
        </section>
      </PageLayout>
    );
  }

  // Convert markdown-style content to JSX
  const renderContent = (text) => {
    const lines = text.trim().split("\n");
    return lines.map((line, i) => {
      const trimmed = line.trim();
      if (!trimmed) return <br key={i} />;
      if (trimmed.startsWith("## ")) return <h2 key={i} className="text-[22px] font-bold mt-10 mb-4" style={{ color: "var(--fg)" }}>{trimmed.replace("## ", "")}</h2>;
      if (trimmed.startsWith("### ")) return <h3 key={i} className="text-[18px] font-semibold mt-8 mb-3" style={{ color: "var(--fg)" }}>{trimmed.replace("### ", "")}</h3>;
      if (trimmed.startsWith("- **")) {
        const match = trimmed.match(/^- \*\*(.+?)\*\*:?\s?(.*)/);
        if (match) return <p key={i} className="text-[14.5px] leading-relaxed ml-2" style={{ color: "var(--fg)", opacity: 0.88 }}><strong>{match[1]}:</strong> {match[2]}</p>;
      }
      if (trimmed.startsWith("- ")) return <p key={i} className="text-[14.5px] leading-relaxed ml-4" style={{ color: "var(--fg)", opacity: 0.85 }}>• {trimmed.replace("- ", "")}</p>;
      if (trimmed.startsWith("|")) return <p key={i} className="text-[13px] font-mono my-1" style={{ color: "var(--fg)", opacity: 0.7, whiteSpace: "pre", overflowX: "auto" }}>{trimmed}</p>;
      return <p key={i} className="text-[14.5px] leading-relaxed mb-3" style={{ color: "var(--fg)", opacity: 0.88 }}>{trimmed}</p>;
    });
  };

  return (
    <PageLayout>
      <SectionReveal>
        <section className="py-20 px-6">
          <div className="max-w-3xl mx-auto">
            <Link
              to="/blog"
              className="inline-flex items-center gap-1.5 text-[13px] font-medium mb-8 transition-colors duration-200"
              style={{ color: "var(--muted)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--brand-cyan)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--muted)")}
            >
              <ArrowLeft size={14} /> Blog'a Dön
            </Link>

            <div className="flex items-center gap-4 mb-4">
              <span className="text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full" style={{ background: "rgba(75,111,212,0.12)", color: "var(--brand-cyan)" }}>
                {post.tag}
              </span>
              <span className="text-[12px] flex items-center gap-1" style={{ color: "var(--muted)" }}>
                <Calendar size={13} /> {post.date}
              </span>
              <span className="text-[12px] flex items-center gap-1" style={{ color: "var(--muted)" }}>
                <Clock size={13} /> {post.readTime}
              </span>
              <span className="text-[12px] flex items-center gap-1" style={{ color: "var(--muted)" }}>
                <User size={13} /> {post.author}
              </span>
            </div>

            {post.bannerImage && (
              <div className="mb-8 rounded-2xl overflow-hidden" style={{ border: "1px solid var(--border)" }}>
                <img
                  src={post.bannerImage}
                  alt={post.title}
                  className="w-full h-auto object-cover"
                  style={{ maxHeight: "420px" }}
                  loading="eager"
                />
              </div>
            )}

            <h1 className="font-bold tracking-tight leading-[1.15] mb-6" style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)", color: "var(--fg)" }}>
              {post.title}
            </h1>

            <div className="prose-custom">
              {renderContent(post.content)}
            </div>

            <div className="mt-16 pt-8" style={{ borderTop: "1px solid var(--border)" }}>
              <Link
                to="/blog"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-[14px] transition-all duration-200"
                style={{ background: "var(--brand-navy)", color: "#fff" }}
              >
                <ArrowLeft size={16} /> Tüm Yazılar
              </Link>
            </div>
          </div>
        </section>
      </SectionReveal>
    </PageLayout>
  );
};

export default BlogPostPage;
